
import React from 'react';

// Componente PilotOffer
const PilotOffer: React.FC = () => {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="piloto" className="py-24 bg-white relative scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-dark rounded-[3rem] p-10 lg:p-20 relative overflow-hidden text-white">
          <div className="absolute top-0 right-0 w-96 h-96 bg-fhir/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
          
          <div className="grid lg:grid-cols-2 items-center gap-12 relative z-10">
            <div>
              <span className="text-fhir font-black text-sm uppercase tracking-widest mb-4 inline-block">Programa de Adopción Temprana</span>
              <h2 className="text-4xl md:text-5xl font-black mb-8 leading-tight italic">
                Impulse su Clínica con <br/><span className="text-fhir">OncoFHIR Prescribe</span>
              </h2>
              <p className="text-gray-400 text-lg mb-8 font-medium">
                Estamos abriendo las puertas a clínicas que buscan modernizar su flujo oncológico con estándares internacionales y soporte dedicado.
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <i className="fas fa-gift text-fhir"></i>
                  <span className="font-black text-fhir">2 meses COMPLETAMENTE GRATIS - Sin compromiso de permanencia</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-check-circle text-onco"></i>
                  <span className="font-bold">Biblioteca precargada de fármacos y protocolos</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-check-circle text-onco"></i>
                  <span className="font-bold">Capacidad de personalización y creación de protocolos propios</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fas fa-check-circle text-onco"></i>
                  <span className="font-bold">Implementación inmediata y soporte prioritario</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8 text-dark text-center lg:translate-x-10 shadow-2xl border border-gray-100">
              <div className="text-gray-400 font-bold uppercase text-[10px] tracking-[0.2em] mb-4">Programa Lanzamiento 2026</div>
              <div className="text-2xl md:text-3xl font-black text-medical mb-2 italic leading-tight">Acceso Preferencial <br/>+ 2 Meses Gratis</div>
              <div className="text-gray-400 font-bold mb-6 text-sm">Beneficio para nuevos Adoptantes</div>
              
              <div className="bg-fhir/10 text-fhir text-xs font-black p-4 rounded-xl mb-8 border border-fhir/20">
                <div className="uppercase tracking-widest mb-1">PROCESO DE ADMISIÓN ABIERTO</div>
                <div className="text-[10px] opacity-80 italic normal-case">Sin costo inicial. Sin tarjeta de crédito. Despliegue ágil.</div>
              </div>

              <button 
                onClick={scrollToContact}
                className="block w-full bg-fhir text-white font-black py-5 rounded-2xl shadow-xl shadow-fhir/30 hover:scale-105 transition-all uppercase tracking-widest"
              >
                UNIRSE AL PROGRAMA
              </button>
              
              <div className="mt-6 flex flex-col items-center gap-2">
                 <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                  Implementación guiada disponible hoy
                </p>
                <div className="w-12 h-0.5 bg-slate-100"></div>
                <p className="text-[9px] text-onco font-black uppercase tracking-widest">
                  Tecnología HL7 FHIR Nativa
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PilotOffer;
